import Vue from 'vue';

export function isMobile(component: Vue): boolean {
  try {
    // BBAA context
    return component.$store.getters['pageHeader/isMobile'](component.$mq);
  } catch (e) {
    // legacy context

    // just in case
    if (process.env.VUE_ENV === 'server') {
      return false;
    }

    // Can't do `await import('@/util/global')` here because that makes this function return a
    // Promise which is truthy when rendering the template
    return document.body.dataset.isMobile === 'true';
  }
}
